import { Box, Typography } from '@mui/material'
import { Countries } from '@xoda/common'
import { t } from 'i18next'
import { FC } from 'react'
import { useRecoilState } from 'recoil'
import { GoodsService, GoodsType } from '../services/goods'
import { gymState } from '../store/gym'
import { themeMeta } from '../theme/meta'

const Checkout: FC<CheckoutProps> = ({ goods, discountedPrice }) => {
  const [gym] = useRecoilState(gymState)

  const price = GoodsService.getRoughPrice(goods)
  const joinFee = GoodsService.isPlan(goods) ? goods.join_fee : 0
  const total = (discountedPrice ?? price) + joinFee

  return (
    <>
      <Typography variant="h3" mb={1}>
        {goods.name}
      </Typography>
      <Typography
        variant="body2"
        color={themeMeta.colors.monochrome.label}
        mb={1}
      >
        {goods.description}
      </Typography>
      <Box
        component="table"
        typography="body1"
        width="100%"
        sx={{
          '& th, & td': {
            py: 0.5,
          },
          '& th': {
            fontWeight: 'normal',
            textAlign: 'start',
          },
          '& td': {
            textAlign: 'end',
          },
          '& tfoot': {
            '&, & th': {
              fontWeight: 600,
            },
          },
        }}
      >
        <tbody>
          <tr>
            <th scope="row">{t('Amount')}</th>
            <td>{Countries.formatAmount(price, gym?.currency_code, true)}</td>
          </tr>
          {typeof discountedPrice !== 'undefined' && (
            <tr>
              <th scope="row">{t('Promo code')}</th>
              <td>
                -
                {Countries.formatAmount(
                  price - discountedPrice,
                  gym?.currency_code,
                  true
                )}
              </td>
            </tr>
          )}
          {!!joinFee && (
            <tr>
              <th scope="row">{t('Join fee')}</th>
              <td>
                {Countries.formatAmount(joinFee, gym?.currency_code, true)}
              </td>
            </tr>
          )}
        </tbody>
        <tfoot>
          <tr>
            <th scope="row">{t('Total')}</th>
            <td>{Countries.formatAmount(total, gym?.currency_code, true)}</td>
          </tr>
        </tfoot>
      </Box>
    </>
  )
}

type CheckoutProps = {
  goods: GoodsType
  discountedPrice?: number
}

export { Checkout }
export type { CheckoutProps }
